module.exports = __webpack_public_path__ + "img/MSMC_Blue_logo_300ppi.a200b407.png";